import { render } from "./globalInfo.vue?vue&type=template&id=386dd9b8&scoped=true"
import script from "./globalInfo.vue?vue&type=script&lang=js"
export * from "./globalInfo.vue?vue&type=script&lang=js"

import "./globalInfo.vue?vue&type=style&index=0&id=386dd9b8&lang=scss&scoped=true"

import exportComponent from "/usr/src/test-oho-sales/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-386dd9b8"]])

export default __exports__